export default {
  message: {
    hello: 'こんにちは',
    welcome: '私たちのウェブサイトへようこそ！',
    login: 'ログイン',
    logout: 'ログアウト',
    about: '私たちについて',
    contact: 'お問い合わせ',
    news: 'ニュース',
    home: 'ホーム',
    industry: '業界応用',
    support: 'サポート',
    faq: 'よくある質問',
    privacy: 'プライバシーポリシー',
    userCenter: 'ユーザーセンター',
    myOrder: '私の注文',
    myPlan: '私のプラン',
    myTeam: '私のチーム',
    myInfo: 'プロフィール',
    myMessage: '私のメッセージ',
    exit: 'ログアウト',
    language: '言語',
    zh: '中国語',
    en: '英語',
    ja: '日本語',
    ko: '韓国語',
    industryNews: '業界ニュース',
    techNews: '技術動向',
    service: 'カスタマーサービス',
    onlineExperience: 'オンラインで究極の圧縮を体験',
    getPro: '個人/チームPRO会員権限を取得',
    originalImage: '元画像',
    compressed: '圧縮後',
    saveSpace: 'スペース節約',
    imageCompress: '画像圧縮',
    supportedImage: 'JPG/JPEG/PNG/GIF/WebP対応',
    addImage: '画像を追加',
    visitorImageTip: '訪問者：一度に20枚まで、各画像最大5MB',
    originalVideo: '元動画',
    videoCompress: '動画圧縮',
    supportedVideo: 'MP4/MOV/AVI/MKV/TS/FLV/Y4M/YUV対応',
    addVideo: '動画を追加',
    visitorVideoTip: '訪問者：一度に1本のみ、最大60MB',
    scrollDown: '下にスクロールすると、さらにクールな機能が',
    windows32: 'Windows(32ビット)ダウンロード',
    windows64: 'Windows(64ビット)ダウンロード',
    selectedUsers: 'すでに',
    users: '人のユーザーが選択',
    ourPartners: '私たちのパートナー',
    localCompressSoftware: 'ローカル動画・画像圧縮ソフト',
    noFileLimit: 'ファイル数・サイズ無制限',
    vipRights: 'VIP特典共有｜オンライン＋ローカル',
    customCompress: 'カスタム圧縮設定、様々なニーズに対応',
    folderOneClick: 'フォルダ一括圧縮',
    address: '中国深圳市南山区桃源街道篤学路9号国家スーパーコンピューティング深圳センター科研ビル7階',
    quickNav: 'クイックナビ',
    technologyIntro: '技術紹介',
    price: '価格',
    copyright: '深圳智慧林ネットワークテクノロジー株式会社',
    icp: '粤ICP备20048602号-2',
    legal: '法的声明',
    siteMap: 'サイトマップ',
    newsBannerTitle: 'ZHL圧縮技術業界応用',
    newsBannerDesc: 'ZHL圧縮（API/SDK）効率的・安全・迅速・専門的',
    contactForApi: 'API/SDKのご利用はお問い合わせください',
    getDoc: '説明書を取得',
    techFeatures: '技術特徴',
    efficientConvenient: '効率的・便利',
    efficientConvenientDesc: 'API/SDK圧縮ソリューションが成熟し、標準化されたドキュメントとフルテクニカルサポートにより、企業開発統合がより便利になり、ZHL圧縮技術を素早く享受できます',
    safeStable: '安全・安定',
    safeStableDesc: '数億回テストされ、サーバーは安全で安定し、送信データは完全に暗号化されています。圧縮処理後、ユーザーデータは自動的に削除され、ユーザーのプライバシーセキュリティを確保します。',
    powerfulAlgorithm: '強力なアルゴリズム',
    powerfulAlgorithmDesc: '複数の独立した独自開発アルゴリズムに基づき、大量データトレーニングと実践的なビジネスシナリオでサポートされ、ソースファイルの完全性を確保することに専念しています。',
    multiLanguageSupport: '多言語・多システム対応',
    multiLanguageSupportDesc: 'C、C++、Java、Goなどの複数のプログラミング言語がLinuxとWindowsプラットフォームに適用可能。パーソナライズされたカスタマイズサービスについては、お問い合わせください。',
    techAdvantages: '技術的優位性',
    techAdvantagesDesc: '独立した知的財産権を持つ独立アルゴリズム、下位層で制御可能で調整可能（顧客のニーズに応じて圧縮戦略を柔軟に調整可能）。人工知能と機械学習技術に基づき、効果を継続的に最適化。圧縮比、圧縮速度、圧縮品質は業界トップレベル（具体的なファイル形式によって程度が異なる）。数学的関係とAI自己学習アーキテクチャに基づき、リソース占有が少なく、ハードウェア要件が低く、柔軟に展開可能。幅広いファイルタイプと多システム対応をサポート。無損失圧縮によりファイル完全性を確保し、トップソフトウェアより70-80%性能が優れている（7-ZIPなどのソフトウェア）。',
    techPrinciples: '技術原理',
    techPrinciplesDesc: '機械学習とAIモデルが数百万のデータポイントを分析し、数学的関係を発見し、独自開発アルゴリズムを使用して異なるタイプのファイルのデータとバイナリ情報を処理し、以前は圧縮不可能だったファイルタイプの圧縮を可能にし、100%無損失圧縮を実現します。',
    imageCompressSdk: '画像圧縮SDK',
    medicalImageSdk: '医療画像圧縮SDK',
    textLogSdk: 'テキスト・ログ圧縮SDK',
    videoStreamSdk: 'ビデオストリームリアルタイム圧縮SDK',
    supportedFormats: '対応フォーマット・オペレーティングシステム',
    supportedFormatsImage: '対応フォーマット：bmp/jpg/png/tif/gif/pcx/tga/exif/fpx/svg/psd/cdr/pcd/dxf/ufo/eps/ai/raw/webp システム：JavaベースのSDK、LinuxとWindowsシステムをサポート',
    supportedFormatsMedical: 'DICOM/NIFTIシステム：Java言語ベース、LinuxとWindowsをサポート。',
    supportedFormatsText: '対応フォーマット：text/RTF/jsonlog/sql/xml/doc//MIME/ASCII… システム：Java言語ベース、LinuxとWindowsをサポート',
    supportedFormatsVideo: 'mp4/mov/mkv/avi/rm/rmvb/mpeg1-4/dat/wmv/3gp/amv/dmv/flv システム：C++言語ベース、LinuxとWindowsシステムをサポート。',
    painPoints: '課題・要件',
    painPointsImage: '高解像度画像の読み込みと送信速度が遅い、大量画像プラットフォームのストレージ圧力が高い、大量ストレージコストが高い、jpeg形式は無損失圧縮をサポートしない',
    painPointsMedical: '医療画像データの規模が巨大（標準病理検査で5G/件に達する可能性）、履歴データが多く、保存期間が長い（10年以上）、完全無損失圧縮が必要（画像を歪めることはできない）',
    painPointsText: '重複冗長データの混雑、ユーザーデータの爆発的増加',
    painPointsVideo: '帯域幅月額レンタルコストの節約、NVRサーバー調達拡張コストの削減、ストレージ/バックアップ/アーカイブリソースの節約、運用・管理コストの削減、コンピュータまたはストレージデバイスの運用負荷の削減',
    featuresEffects: '特徴・効果',
    featuresEffectsImage: '高品質圧縮品質保持、ストレージスペースとコストの効果的な節約、ファイル流通の加速、データセンター建設コストの節約、帯域幅月額レンタルコストの節約、ウェブページ読み込み速度の向上。',
    featuresEffectsMedical: 'ストレージスペースを大幅に削減、医療機関のストレージ/バックアップ/アーカイブ機器購入サイクルを延長、ストレージ/バックアップ/アーカイブコストを削減。ストレージ/バックアップ/アーカイブリソースを大幅に節約、運用・管理コストを削減。コンピュータまたはストレージデバイスの運用負荷を削減。データ送信速度を加速、ユーザーエクスペリエンスを大幅に向上。医療画像データの検索とコール効率を向上。',
    featuresEffectsText: '5つの圧縮速度から選択可能。圧縮後ファイルがより小さく、送信がより高速。解凍ファイルコストがストレージと送信コストより低い。',
    featuresEffectsVideo: '金融、データセンター、エッジコンピューティング、ブロックチェーン、IoTなど。セキュリティ監視、120救急車、指揮センタースマート交通など。',
    suitableScenarios: '適切なシナリオ',
    suitableScenariosImage: '博物館、アーカイブ、金融業界、政府機関、大型オンラインショッピングプラットフォーム、ニューメディア、素材ライブラリ、映画・テレビなど',
    suitableScenariosMedical: '主に医療機関のPACSシステム、医療画像クラウドなどのシナリオに適用',
    suitableScenariosText: '金融、データセンター、エッジコンピューティング、ブロックチェーン、IoTなど',
    suitableScenariosVideo: 'セキュリティ監視、120救急車、指揮センタースマート交通など',
    // FAQ page new translation keys
    faqTitle: 'よくある質問',
    faqBreadcrumbHome: 'ホーム',
    faqBreadcrumbService: 'サポート',
    faqBreadcrumbFaq: 'よくある質問',
    faqQuestionAnswer: '質問と回答',
    faqQ1Title: '訪問者とPROメンバーの違いは何ですか？',
    faqQ1Content: '訪問者は画像圧縮機能を使用する際、一度に最大20枚の画像をアップロードでき、各画像は最大5MBに制限されています。PROメンバーは一度に無制限の画像をアップロードでき、各画像のサイズに制限はありません。動画圧縮では、訪問者は一度に1つの動画ファイルをアップロードでき、各動画は最大60MBに制限されています。PROメンバーは一度に1つの動画ファイルをアップロードでき、各動画は最大2GBに制限されています。',
    faqQ2Title: 'PROメンバーになるにはどうすればよいですか？',
    faqQ2Content: 'ユーザーはメールやWeChatでウェブサイトにログインできます。ユーザーになった後、「価格」をクリックしてPROメンバーシップ購入画面に入り、支払い後、私たちの名誉あるPROメンバーになります。',
    faqQ3Title: 'アップロードされた画像/動画はどのように処理されますか？',
    faqQ3Content: 'ユーザーがアップロードしたファイルは、私たちのバックエンドサーバーで圧縮され、圧縮後にユーザーがダウンロードします。私たちはこれらのファイルを1時間だけ保持し、ファイルの圧縮状況を記録して圧縮技術を最適化します。1時間後に即座に削除され、プライバシー漏洩のリスクはありません。',
    faqQ4Title: '請求書の申請はどうすればよいですか？',
    faqQ4Content: 'Yasubitで100元以上消費したユーザーは、カスタマーサービスQQを通じてYasubitチームに連絡して請求書を請求できます。',
    faqQ5Title: '画像や動画のドラッグ&ドロップアップロードが成功しないのはなぜですか？',
    faqQ5Content: 'ブラウザのバージョンが統一されていないため、オンラインサービスを使用する際に一部のユーザーが圧縮やアップロードの問題に遭遇する可能性があります。Google ChromeやFirefoxブラウザの使用をお勧めします。',
    faqQ6Title: '圧縮設定はどのように使用しますか？',
    faqQ6Content: '画像圧縮を使用する際、ユーザーは自分のニーズに応じて圧縮品質を選択できます。圧縮品質が高いほど（1が最高）、圧縮後のファイルが大きくなります。圧縮品質が低いほど（13が最低）、圧縮後のファイルが小さくなります。動画圧縮は画像圧縮と同じ原理で動作します。ただし、動画圧縮では圧縮品質に加えて、動画の出力形式も選択できます。圧縮設定を変更しない場合（デフォルトモード）、圧縮比と圧縮品質はバランスが取れ、圧縮後の動画や画像は元の動画や画像と視覚的・聴覚的に違いがありません。',
    faqQ7Title: 'なぜ一部の画像や動画は圧縮後あまり小さくならないのですか？',
    faqQ7Content: 'Yasubitはほとんどの動画や画像で優れた圧縮効果を達成できます。圧縮効果が一般的なものについては、主な理由はこれらの動画や画像が既に深く圧縮されていることです。したがって、明らかな視覚的差異を引き起こすことなく、さらに圧縮することはできません。ユーザーがより小さな圧縮動画や画像を必要とする場合、圧縮設定を行うことでこれを実現できます。',
    faqQ8Title: 'YasubitクライアントソフトウェアVIPとYasubitウェブサイトPROメンバーシップアカウントは互換性がありますか？',
    faqQ8Content: 'YasubitクライアントVIPはYasubitウェブサイトにログインして、ウェブサイトと同じPROメンバーの圧縮権限を享受できます。逆に、ウェブサイトのPROメンバーもクライアントにログインして、クライアントと同じVIP圧縮権限を享受できます。ファイルサイズと数量に制限がないため、クライアントのダウンロード使用をお勧めします。',
    // Contact page translation keys
    contactTitle: 'お問い合わせ',
    contactBreadcrumbHome: 'ホーム',
    contactBreadcrumbService: 'サポート',
    contactBreadcrumbContact: 'お問い合わせ',
    customerService: 'カスタマーサービス',
    customerServiceQQ: 'QQ: 3985723352',
    contactCustomerService: 'カスタマーサービスに連絡',
    businessCooperation: 'ビジネス協力',
    businessCooperationDesc: 'ビジネス協力については、メールでお問い合わせください。',
    businessEmail: 'メール: support@zhihuilin.net',
    leaveMessage: 'メッセージを残す',
    yourName: 'お名前:',
    contactInfo: '連絡先:',
    yourEmail: 'メールアドレス:',
    messageContent: 'メッセージ内容（200文字以内）',
    submit: '送信',
    submitSuccess: '送信成功',
    submitFailed: '送信に失敗しました。後でもう一度お試しください',
    completeInfo: 'すべての情報を入力してください',
    // About page translation keys
    aboutTitle: '会社概要',
    aboutBreadcrumbHome: 'ホーム',
    aboutBreadcrumbAbout: '会社概要',
    companyProfile: '会社紹介',
    companyProfileContent: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <a href="http://www.zhihuilin.net/" target="_blank" title="ZHL公式サイト">深セン智慧林ネットワークテクノロジー株式会社</a>は2015年に設立され、人工知能、データ圧縮、通信伝送加速などの技術基盤アルゴリズムおよびその応用開発に取り組む国家ハイテク企業です。完全な独自知的財産権を持つ新世代AIコアアルゴリズムとディープラーニング技術、世界トップレベルのデータ超圧縮技術、グローバルに革新的な通信伝送加速技術を次々と開発し、これらの技術を活用して多くの政府・企業顧客に業界アプリケーションソリューションとカスタマイズ製品を提供しています。<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2017年以降、同社は何度も国家ハイテク企業に認定されており、科学技術部トーチセンターのテクノロジー型中小企業、深セン市のイノベーティブ中小企業、高成長企業、深セン市ソフトウェア業界協会理事、深セン市情報技術応用イノベーション連盟会員、インダストリアルインターネット連盟、工信部科産金プロジェクトライブラリの最初の入居プロジェクトなどに選ばれています。技術革新能力を維持するため、同社は4人の（Aクラス）外国専門家を導入し、そのうち2人は外国ハイエンド人材および広東省外国ハイレベル人材の称号を獲得しています。完全な独自知的財産権を持つコア技術発明特許を63件申請し、発明特許証書7件、その他の特許証書9件、PCT国際特許8件、ソフトウェア著作権証書66件、科学技術調査報告およびソフトウェアテスト報告40件以上、登録商標12件を取得しています。科学的かつ規範的な管理のため、同社はISO 9001品質管理システム認証、知的財産管理システム認証を取得しています。<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 同社は「誠実を本とし、継続的なイノベーション、最大限に顧客のニーズを満たすこと」を宗旨とし、優れた製品と高品質なサービスで顧客のコスト削減と効率向上、エネルギー節約と排出削減を実現し、協力とウィンウィンを目指します。<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span style="font-size: 20px;">基盤技術の継続的イノベーション&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 完全な独自知的財産権&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 約10年の理論と技術の蓄積<br/><br/><br/></span><br/><br/>',
    companyHonor: '関連資格',
    softwareCopyright: 'ソフトウェア著作権',
    patentApplied: '出願済み発明特許',
    patentGranted: '認可済み発明特許',
    // Privacy page translation keys
    privacyTitle: 'プライバシーポリシー',
    privacyBreadcrumbHome: 'ホーム',
    privacyBreadcrumbService: 'サービスとサポート',
    privacyBreadcrumbPrivacy: 'プライバシーポリシー',
    privacyContent: `Yasubit画像圧縮サービスを利用する前に、本規約をよくお読みください。本規約に同意しない場合は、Yasubitのサービスの利用を中止できます。サービスを利用した場合、本規約のすべての内容を認め、受け入れたものとみなされます。<br/><br/>1. Yasubitを通じて圧縮されたマルチメディアファイル（生成された一時URLリンクを含む）は、ユーザーまたは所有者が提供したものです（以下「第三者ファイル」といいます）。Yasubitはオンライン圧縮およびバイト削減機能のみを提供し、Yasubitのいかなる意見や主張も反映せず、また第三者ファイルのいかなる内容、主張、立場にも同意または支持するものではありません。Yasubitは、第三者ファイルの内容の合法性、正確性、真実性、適用性、安全性などについて一切責任を負いません。<br/><br/>2. Yasubitが提供するオンラインインテリジェント圧縮機能は、第三者ファイルを一時的に保存する必要がありますが、長期保存はしません。提出/アップロードされたすべてのファイルは60分ごとに自動的に削除され、削除後はファイルリンクが無効になります。Yasubitが提供するファイルリンクに過度に依存しないでください。<br/><br/>3. Yasubitを利用して、以下の内容をアップロード、圧縮、ダウンロード、コピー、公開、配信、転載してはなりません：<br/>1）憲法で定められた基本原則に反する内容<br/>2）国家の安全を脅かす、国家機密を漏洩する、国家政権を転覆する、国家統一を破壊する内容<br/>3）国家の名誉と利益を損なう内容<br/>4）民族的憎悪や差別を煽動し、民族団結を破壊する内容<br/>5）国家の宗教政策を破壊し、カルトや封建迷信を宣伝する内容<br/>6）デマを流し、社会秩序を乱し、社会の安定を破壊する内容<br/>7）わいせつ、ポルノ、ギャンブル、暴力、殺人、テロ、犯罪教唆の内容<br/>8）他人を侮辱または中傷し、他人の合法的権益を侵害する内容<br/>9）法律や行政法規で禁止されているその他の内容<br/><br/>4. 第三者ファイルの内容（画像、音声、動画、文書、リンクなど）を利用して取引やその他の行為を行う場合は、その合法性、正確性、真実性、実用性、安全性（第三者ファイルの内容をダウンロードすることでコンピュータウイルスに感染するかどうかを含む）を慎重に判断し、十分な予防措置を講じてください。内容の合法性、正確性、真実性、実用性、安全性に不安がある場合は、専門家にご相談ください。<br/><br/>5. 第三者ファイルの情報、サービス、製品などを信じて利用したり、それに基づいて取引等を行った結果生じた人身傷害、財産損害（ダウンロードによるコンピュータウイルス感染を含む）、名誉や信用の毀損、著作権や知的財産権の侵害等の事件、およびそれによる損害について、Yasubitは一切責任を負いません。これらの責任は第三者ファイルの所有者が負うものとします。Yasubitは、Yasubitと直接関係のない取引や行為について、いかなる直接的、間接的、付随的、派生的な損失や責任も負いません。<br/><br/>6. Yasubitサービスを通じて取得した第三者ファイルの内容が合法的な著作権を侵害していると思われる場合は、「情報ネットワーク伝播権保護条例」に従い、書面でYasubitに速やかに通知し、身分証明書、権利証明書、詳細な侵害状況証明を提出してください。Yasubitはこれらの書類を受領後、速やかに当該内容へのサービスリンクを切断します。リンクが切断された第三者ファイルの所有者が、Yasubitの判断が他人の合法的著作権を侵害していないと考える場合は、「情報ネットワーク伝播権保護条例」に従い、リンク切断が同条例に違反しない旨の反通知をYasubitに提出する権利があります。主張が虚偽であった場合は、同条例に従い、関連する法的責任を負うことになりますのでご注意ください。<br/><br/>7. Yasubitは、国家の法律や規則の変更およびユーザー権益保護の必要に応じて、本規約を随時修正することがあります。変更後の規約は、本規約内で明確に表示され、最終更新日が記載されます。`,
    buyNow: '今すぐ購入',
    payTip: 'WeChat Payに対応しています。プライバシーポリシーをよくお読みください。サービスを購入した場合、自動的に',
    invoiceTip: '*累計消費額が100元を超えた場合、カスタマーサービスQQに連絡して請求書を発行できます。普通請求書と専用請求書の両方に対応しています。',
    price_1: '日次会員',
    price_2: '月次会員',
    price_3: '年次会員',
    price_4: '2年会員',
    price_5: '5年会員',
    price_6: '10年会員',
    price_7: '永久会員',
    price_8: '四半期会員',
    price_desc_1: '日次会員はウェブサイトのみ利用可能<br>画像数無制限<br>ファイルサイズ無制限',
    price_desc_2: 'クライアントで動画サイズ無制限<br>画像数無制限<br>ファイルサイズ無制限',
    price_desc_3: 'クライアントで動画サイズ無制限<br>画像数無制限<br>ファイルサイズ無制限',
    price_desc_4: 'クライアントで動画サイズ無制限<br>画像数無制限<br>ファイルサイズ無制限',
    price_desc_5: 'クライアントで動画サイズ無制限<br>画像数無制限<br>ファイルサイズ無制限',
    price_desc_6: 'クライアントで動画サイズ無制限<br>画像数無制限<br>ファイルサイズ無制限',
    price_desc_7: 'クライアントで動画サイズ無制限<br>画像数無制限<br>ファイルサイズ無制限',
    price_desc_8: 'クライアントで動画サイズ無制限<br>画像数無制限<br>ファイルサイズ無制限',
    priceTitle: 'お客様の作業シーンに合った購入プランを選択してください',
    proMemberCount: 'すでに3876人がPRO版会員になりました',
    personalVersion: '個人版',
    teamVersion: 'チーム版',
    videoImageCompress: '動画+画像圧縮',
    duration: '利用期間',
    unlimitedVideoSize: 'クライアントで動画サイズ無制限',
    unlimitedImageCount: '画像数無制限',
    unlimitedFileSize: 'ファイルサイズ無制限',
    selectTeamMember: 'チームメンバー数を選択してください',
    selectDuration: '会員期間を選択してください',
    selectPackage: 'パッケージを選択してください',
    needMoreHelp: 'さらにサポートが必要ですか？',
    confirmPurchase: '本当によろしいですか？本当によろしいですか？本当によろしいですか？本当によろしいですか？本当によろしいですか？本当によろしいですか？',
    yes: 'はい',
    no: 'いいえ',
    orderCreatedSuccess: '注文が正常に作成されました',
    orderName: '注文名',
    orderAmount: '注文金額',
    payMethod: '支払方法',
    orderStatus: '取引状況',
    action: '操作',
    pending: '未払い',
    paid: '支払い済み',
    applyInvoice: '請求書申請',
    delete: '削除',
    goPay: '支払う',
    noData: 'データなし',
    planName: 'プラン名',
    planType: 'プランタイプ',
    memberTime: '会員期間',
    memberCount: '利用メンバー数',
    personal: '個人',
    team: 'チーム',
    daysLeft: '残り{days}日',
    teamInfo: 'チーム情報',
    teamId: 'チームID',
    teamMemberCount: 'チーム人数',
    teamPlanName: 'プラン名',
    teamPlanTime: 'プラン期間',
    myMembers: '私のメンバー',
    admin: '管理者',
    addMember: '新メンバー追加',
    inputNewMemberId: '新メンバーIDを入力してください',
    add: '追加',
    createTeam: 'チーム作成',
    noTeamTips: 'まだチームがありません。クリックして作成しましょう',
    userName: 'ユーザー名',
    userId: 'ID',
    password: 'パスワード',
    changePassword: 'パスワード変更',
    bindEmail: 'メールを紐付け',
    bindInviter: '招待者の電話番号を紐付け',
    changePasswordTitle: 'パスワード変更',
    oldPassword: '旧パスワードを入力',
    newPassword: '新パスワードを入力',
    repeatNewPassword: '新パスワードを再入力',
    passwordRule: '8-20文字、英字/数字/記号のうち2種類以上',
    confirm: '確認',
    cancel: 'キャンセル',
    deleteSuccess: '削除成功',
    passwordNotMatch: '2回入力した新パスワードが一致しません！',
    changeSuccess: '変更成功、再ログインしてください',
    remove: '削除',
    people: '人',
    fileName: 'ファイル名',
    originalFileSize: '元ファイルサイズ',
    status: '状態',
    compressedFileSize: '圧縮後ファイルサイズ',
    fileSizeReduced: 'ファイルサイズ削減',
    merging: 'マージ中...',
    resume: '続行',
    pause: '一時停止',
    download: 'ダウンロード',
    clickOrDragToAddImage: 'クリックまたはドラッグして画像を追加',
    continueToAddImage: '画像を追加し続ける',
    startCompress: '圧縮開始',
    uploading: 'アップロード中',
    compressing: '圧縮中',
    downloadAll: 'すべてダウンロード',
    startDownloading: 'パッケージングしてダウンロード中です。しばらくお待ちください…',
    uploadedCount: '{count}枚の画像をアップロード',
    downloadFailed: 'ダウンロードに失敗しました。再試行してください',
    uploadComponentInitFailed: 'アップロードコンポーネントの初期化に失敗しました。ページをリフレッシュして再試行してください。',
    imageAlreadyExists: 'この画像はすでに存在します',
    allFilesExist: 'すべてのファイルはすでに存在します',
    guestMaxUpload: 'ゲストユーザーは一度に最大{count}枚の画像しかアップロードできません。',
    guestImageSizeLimit: '画像{name}は{size}MBの制限を超えています。ゲストユーザーは{size}MBを超える画像をアップロードできません。',
    uploadFailed: '{name} のアップロードに失敗しました: {msg}',
    noDownloadableFiles: 'ダウンロード可能な圧縮ファイルがありません',
    createZipFailed: 'ZIPファイルの作成に失敗しました。再試行してください',
    resumeUploadFailed: 'アップロードの再開に失敗しました。再試行してください',
    pauseUploadFailed: 'アップロードの一時停止に失敗しました。再試行してください',
    unknownError: '不明なエラー',
    guestSurveyTitle: 'Yasubitサイト体験アンケート',
    questionCount: '全{count}問',
    fillTextareaPlaceholder: '5文字以上で入力してください',
    fillAllQuestions: 'すべての質問にご回答ください',
    submitSuccess: '送信が成功しました',
    compressionFailed: '圧縮に失敗しました',
    compressionFailedWithName: '{name} の圧縮に失敗しました',
    clickOrDragToAddVideo: "クリックまたはドラッグして動画を追加",
    continueToAddVideo: "動画を追加し続ける",
    guestQ1: '1.あなたの性別は？',
    guestQ1_option1: '男性',
    guestQ1_option2: '女性',
    guestQ2: '2.あなたの年齢は？',
    guestQ2_option1: '18歳未満',
    guestQ2_option2: '18~24歳',
    guestQ2_option3: '24~32歳',
    guestQ2_option4: '32歳以上',
    guestQ3: '3.ご職業は？',
    guestQ3_option1: 'IT',
    guestQ3_option2: 'デザイン',
    guestQ3_option3: '写真',
    guestQ3_option4: '教師',
    guestQ3_option5: '学生',
    guestQ3_option6: '管理/財務',
    guestQ3_option7: 'その他',
    guestQ4: '4.普段どのようなコンテンツに注目していますか？',
    guestQ4_option1: 'オリジナル動画',
    guestQ4_option2: 'デザイン素材',
    guestQ4_option3: '写真',
    guestQ4_option4: 'ITコンサル',
    guestQ4_option5: 'その他',
    guestQ5: '5.ファイルを圧縮する目的は？',
    guestQ5_option1: 'ウェブサイト構築',
    guestQ5_option2: 'ファイルアップロード',
    guestQ5_option3: 'ファイル送信',
    guestQ5_option4: 'プログラム速度向上',
    guestQ5_option5: 'その他',
    guestQ6: '6.どのくらいの頻度で当サイトを利用しますか？',
    guestQ6_option1: '毎日',
    guestQ6_option2: '毎週',
    guestQ6_option3: '毎月',
    guestQ6_option4: '一時的',
    guestQ7: '7.Pro会員としてどんなサービスを期待しますか？',
    guestQ7_placeholder: 'ご意見・ご要望を5文字以上でご記入ください',
    guestQ8: '8.どこで当サイトを知りましたか？',
    guestQ8_option1: 'Baidu検索',
    guestQ8_option2: 'フォーラム（知乎、Tieba、CSDN等）',
    guestQ8_option3: '友人の紹介',
    guestQ8_option4: 'その他',
    guestQ9: '9.当サイトのオンライン圧縮機能に満足していますか？',
    guestQ9_option1: '満足',
    guestQ9_option2: '不満',
    guestQ10: '10.ご意見・ご要望があればご記入ください',
    unsupportedImageFormat: 'サポートされていない画像形式です',
    unsupportedVideoFormat: 'サポートされていない動画形式です',

  },
  profile: 'プロフィール',
} 